import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'alumni-service-view-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './alumni-service.part.html',
})
export class AlumniServiceViewPart {
}